import { Link, useLocation } from "react-router-dom";
import "../dashboard/Styles/Components.css";
import { useEffect, useState } from "react";
import { AiOutlineFileText } from "react-icons/ai";
import DomainDisabledOutlinedIcon from "@mui/icons-material/DomainDisabledOutlined";
import permissionConfig from "../dashboard/permissionConfig";
import { useAuth } from "../../context/AuthContext";
import { getAuthRole } from "../../utils/authHelpers";

const SidebarData = ({ toggle }) => {
  const location = useLocation();
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
  const { auth } = useAuth();
  const [menuItems, setMenuItems] = useState([]);

  // FULL_MENU definition
  const FULL_MENU = [
    // {
    //   name: "Dashboard",
    //   icon: require("../dashboard/images/home (2).png"),
    //   path: "/dashboard",
    // },

    {
      name: "Settings",
      icon: require("../dashboard/images/setting.png"),
      path: "/settings",
      subMenu: [
        {
          name: "Services",
          icon: <AiOutlineFileText />,
          path: "/settings/services",
        },
        {
          name: "Booking Categories",
          icon: <AiOutlineFileText />,
          path: "/settings/booking-categories",
        },
        {
          name: "Care Reasons",
          icon: <AiOutlineFileText />,
          path: "/settings/care-reasons"
        },
        {
          name: "ResourceType",
          icon: <AiOutlineFileText />,
          path: "/settings/resourcetype",
        },
        {
          name: "Languages",
          icon: <AiOutlineFileText />,
          path: "/settings/languages",
        },
        {
          name: "Location",
          icon: <AiOutlineFileText />,
          path: "/settings/prefered-zone",
        },
        {
          name: "Preferred Time",
          icon: <AiOutlineFileText />,
          path: "/settings/preferred-time",
        },
        {
          name: "Urgencies",
          icon: <AiOutlineFileText />,
          path: "/settings/urgencies",
        },
        {
          name: "Lead Status",
          icon: <AiOutlineFileText />,
          path: "/settings/status",
        },
        {
          name: "Googlemapkey",
          icon: <AiOutlineFileText />,
          path: "/settings/googlemapkey",
        },
        {
          name: "Available-Shifts",
          icon: <AiOutlineFileText />,
          path: "/settings/availble-shifts",
        },
        {
          name: "Days-Available",
          icon: <AiOutlineFileText />,
          path: "/settings/days-available",
        },
        {
          name: "Education-Levels",
          icon: <AiOutlineFileText />,
          path: "/settings/education-levels",
        },
        {
          name: "Hospital-Facilities",
          icon: <AiOutlineFileText />,
          path: "/settings/hospital-facilities",
        },
        {
          name: "Facility-Service",
          icon: <AiOutlineFileText />,
          path: "/settings/facility-service",
        },
        {
          name: "States",
          icon: <AiOutlineFileText />,
          path: "/settings/states",
        },
        {
          name: "Districts",
          icon: <AiOutlineFileText />,
          path: "/settings/districts",
        },
        {
          name: "Cities",
          icon: <AiOutlineFileText />,
          path: "/settings/cities",
        },
        {
          name: "Co-Ordinators",
          icon: <AiOutlineFileText />,
          path: "/settings/co-ordinator",
        },
        {
          name: "Managers",
          icon: <AiOutlineFileText />,
          path: "/settings/managers",
        },
        {
          name: "Lead-Source",
          icon: <AiOutlineFileText />,
          path: "/settings/lead-source",
        },
        {
          name: "Interaction-Type",
          icon: <AiOutlineFileText />,
          path: "/settings/interaction-type",
        },
        {
          name: "Interaction-Channel",
          icon: <AiOutlineFileText />,
          path: "/settings/interaction-channel",
        },
        {
          name: "Interaction-Outcome",
          icon: <AiOutlineFileText />,
          path: "/settings/interaction-outcome",
        },
        {
          name: "FollowUpMode",
          icon: <AiOutlineFileText />,
          path: "/settings/followupmode",
        },

        {
          name: "AssessmentType",
          icon: <AiOutlineFileText />,
          path: "/settings/assessment-type",
        },
        {
          name: "AssessmentMode",
          icon: <AiOutlineFileText />,
          path: "/settings/assessment-mode",
        },
        // {
        //   name: "RiskCategory",
        //   icon: <AiOutlineFileText />,
        //   path: "/settings/risk-category", no need i done it below
        // },
        {
          name: "ResourceCategory",
          icon: <AiOutlineFileText />,
          path: "/settings/resource-category",
        },
        {
          name: "Relations",
          icon: <AiOutlineFileText />,
          path: "/settings/relations",
        },
        {
          name: "Tariffs",
          icon: <AiOutlineFileText />,
          path: "/settings/tariffs",
        },
        {
          name: "Clinical Stability Masters",
          icon: <AiOutlineFileText />,
          path: "/settings/clinical-stability-masters"
        },
        {
          name: "Frequency Masters",
          icon: <AiOutlineFileText />,
          path: "/settings/frequency-masters"
        },
        {
          name: "Speciality Master",
          icon: <AiOutlineFileText />,
          path: "/settings/specialities"
        },
        {
          name: "Medical Equipments",
          icon: <AiOutlineFileText />,
          path: "/settings/medical_equipments"
        },
        {
          name: "Systematic Categories",
          icon: <AiOutlineFileText />,
          path: "/settings/systematic-categories"
        },
        {
          name: "Systematic Status",
          icon: <AiOutlineFileText />,
          path: "/settings/systematic-status-master"
        },
        {
          name: "Risk Categories",
          icon: <AiOutlineFileText />,
          path: "/settings/risk-categories"
        },
        {
          name: "Risk Levels",
          icon: <AiOutlineFileText />,
          path: "/settings/risk-levels"
        },
        {
          name: "ADL Categories",
          icon: <AiOutlineFileText />,
          path: "/settings/adl-categories"
        },
        {
          name: "ADL Choices",
          icon: <AiOutlineFileText />,
          path: "/settings/adl-score"
        },
        {
          name: "Vital Categories",
          icon: <AiOutlineFileText />,
          path: "/settings/vital-categories"
        },
        {
          name: "Vital Choices",
          icon: <AiOutlineFileText />,
          path: "/settings/vital-choices"
        },
        {
          name: "Comorbidity Master",
          icon: <AiOutlineFileText />,
          path: "/settings/comorbidity-master"
        },
        {
          name: "Skill Level Master",
          icon: <AiOutlineFileText />,
          path: "/settings/skill-level-master"
        },
        {
          name: "Medication Complexities",
          icon: <AiOutlineFileText />,
          path: "/settings/medication-complexities"
        },
        {
          name: "Home Readiness",
          icon: <AiOutlineFileText />,
          path: "/settings/home-readiness"
        },
        {
          name: "Scenario Categories",
          icon: <AiOutlineFileText />,
          path: "/settings/scenario-categories"
        },
        {
          name: "Scenario Choices",
          icon: <AiOutlineFileText />,
          path: "/settings/scenario-choices"
        },
        {
          name: "Physiotherapy Types",
          icon: <AiOutlineFileText />,
          path: "/settings/physiotherapy-types"
        },
        {
          name: "Nursing Procedures",
          icon: <AiOutlineFileText />,
          path: "/settings/nursing-procedures"
        }

      ],
    },
    {
      name: "Work List",
      icon: require("../dashboard/images/branches.png"),
      path: "/worklist",
      subMenu: [
        {
          name: "My Work List",
          icon: <AiOutlineFileText />,
          path: "/worklist/myworklist",
        },

        {
          name: "Profile",
          icon: <AiOutlineFileText />,
          path: "/settings/profile",
        },
        {
          name: "Carepreneur",
          icon: <AiOutlineFileText />,
          path: "/worklist/carepreneur",
        },
        {
          name: "Hospital",
          icon: <AiOutlineFileText />,
          path: "/worklist/hospital",
        },
      ],
    },
    {
      name: "Marketing",
      icon: <DomainDisabledOutlinedIcon style={{ verticalAlign: "middle" }} />,
      path: "/marketing",
      subMenu: [
        {
          name: "Blog Categories",
          icon: <AiOutlineFileText />,
          path: "/marketing/blog-categories",
        },
        {
          name: "Blog Posts",
          icon: <AiOutlineFileText />,
          path: "/marketing/blog-posts",
        },
        {
          name: "Contacts",
          icon: <AiOutlineFileText />,
          path: "/marketing/contacts",
        },
        {
          name: "Seo-Url",
          icon: <AiOutlineFileText />,
          path: "/marketing/seo-url",
        },
      ],
    },
  ];

  const filterMenu = (menu, allowed) => {
    return menu
      .filter((item) => allowed.includes(item.name))
      .sort(
        (a, b) => allowed.indexOf(a.name) - allowed.indexOf(b.name)
      )
      .map((item) => {
        const newItem = { ...item };
        if (newItem.subMenu) {
          newItem.subMenu = filterMenu(newItem.subMenu, allowed);
        }
        return newItem;
      });
  };

  useEffect(() => {
    const role = auth?.role || getAuthRole();
    const config = permissionConfig.find((item) => item.role === role);

    if (config) {
      const filtered = filterMenu(FULL_MENU, config.show);

      const updatedMenu = filtered.map((item) => ({
        ...item,
        active: location.pathname.startsWith(item.path),
      }));

      setMenuItems(updatedMenu);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth?.role, location.pathname]);

  const toggleDropdown = (index) => {
    setOpenDropdownIndex(openDropdownIndex === index ? null : index);
  };

  return (
    <div className={toggle ? "sidebar" : "sidebar-hide"}>
      <ul className="menu">
        {menuItems.map((item, index) => (
          <li key={index}>
            <Link
              to={item.subMenu && item.subMenu.length > 0 ? "#" : item.path}
              className={`menu-item ${item.active ? "active" : ""}`}
              onClick={(e) => {
                if (item.subMenu && item.subMenu.length > 0) {
                  e.preventDefault();
                  toggleDropdown(index);
                }
              }}
            >
              <div className="icon-container">
                {typeof item.icon === "string" ? (
                  <img src={item.icon} alt={item.name} />
                ) : (
                  item.icon
                )}
              </div>
              {item.name}
              {item.subMenu && item.subMenu.length > 0 && (
                <span style={{ marginLeft: "auto" }}>
                  {openDropdownIndex === index ? "▲" : "▼ "}
                </span>
              )}
            </Link>

            {item.subMenu && item.subMenu.length > 0 && openDropdownIndex === index && (
              <ul className="submenu">
                {item.subMenu.map((subItem, subIndex) => (
                  <li key={subIndex}>
                    <Link
                      to={subItem.path}
                      className={`menu-item ${location.pathname.startsWith(subItem.path)
                        ? "active"
                        : ""
                        }`}
                    >
                      {subItem.icon}
                      {subItem.name}
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SidebarData;
